import { type Configuration, LogLevel } from '@azure/msal-browser';
import type { RuntimeConfig } from '../config/runtimeConfig';

export function buildMsalConfig(cfg: RuntimeConfig): Configuration {
  return {
    auth: {
      clientId: cfg.clientId,
      authority: cfg.authority,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: 'sessionStorage',
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message) => {
          if (level <= LogLevel.Warning) {
            // eslint-disable-next-line no-console
            console.log(`[msal] ${message}`);
          }
        },
        logLevel: LogLevel.Warning,
      },
    },
  };
}

export function buildLoginRequest(_cfg: RuntimeConfig): { scopes: string[]; prompt: string } {
  // Login carries OIDC scopes ONLY. The API scope (api://<clientId>/access_as_user) is requested
  // separately at token-acquisition time (see buildApiScopes / useAuth.acquireApiToken). Mixing the
  // API scope into the interactive login request makes sign-in fail when that scope isn't yet
  // exposed/consented — so we keep them split.
  //
  // prompt: 'select_account' forces the AAD "Pick an account" screen instead of silently
  // reusing the browser's existing session (e.g. the Windows-joined Entra account). This lets
  // the user choose or add a different account on every explicit sign-in.
  return { scopes: ['openid', 'profile', 'offline_access'], prompt: 'select_account' };
}

export function buildApiScopes(cfg: RuntimeConfig): string[] {
  return [cfg.apiScope];
}

